/* eslint-disable */
// app jsbridge提供的请求方法
/*
 * @Author: wyh
 * @Date: 2020-04-23 11:06:08
 * @Last Modified by: wyh
 * @Last Modified time: 2020-06-04 21:12:57
 */
import {getApiHost} from './getApiHost.js'
const apiHost = getApiHost()
console.log('apiHost',apiHost)
function yyRequest(url, param = {}, time, sign) {
  // auth改造 代驾接口增加参数domainType=200
  param.domainType = 200
  const obj = {
    'action': 'yyrequest',
    'url': url,
    'method': 'post',
    'aosSign': {
      'aos_params': true,
      'ent': true,
      'aos_params_inbody': false,
      'sign': sign
    },
    'headers': {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json',
      // 'Content-Type': 'text/javascript'
    },
    'timeout': time || 15000,
    'body': param,
    'bodytransfer': false
  }
    // this.$toast(res+'???')
    // callback(content);
  return new Promise((reslove,rej) => {
    let timer = null;
    if (time) {
      timer = setTimeout(() => {
        rej({msg:'网络超时，请稍后重试'})
      },time)
    }

    window.AmapApp.bridge.send(obj, function (res) {
      let content = res && res.content;
      if (content && typeof content === 'string') {
        content = JSON.parse(content);
      }
      if (timer) {
        clearTimeout(timer)
      }
      if (!navigator.onLine) {
        const networkError = {
          code: 9999,
          msg: '网络异常，请检查网络状态后重试'
        }
        reslove(networkError)
      }
      reslove(content)
    })
  })
}

const yyrequest = (url, param = {}, time, sign, callback) => {
  const realUrl = apiHost + url;
  console.log(realUrl, '===校验走端内还是端外')
  yyRequest(realUrl, param, time, sign).then((res) => {
    callback(res)
  }).catch((res) => {
    callback(res)
  });
}

export {
  yyrequest
};
